<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg1">
    <div class="container">
        <div class="inner-title text-center">
            <h3>{{categoryName || 'الاقسام'}}</h3>
        </div>
    </div>
</div>

<section class="category-area pt-100 pb-70" *ngIf="categories">
    <div class="container">
        <div class="section-title ">
            <span>الاقسام</span>
            <h2>استخدم البحث عن طريق الاقسام</h2>
        </div>
        
        <div class="row pt-45">
            <div class="col-lg-4 col-sm-6" *ngFor="let category of categories;let i = index;trackBy: trackById">
                <div class="category-card">
                    <a [href]="'category/' + category.id + '/' + category.name">
                        <img src="{{category?.avatar}}" width="110" alt="category">
                    </a>
                    <a [href]="'category/' + category.id + '/' + category.name"><h3>{{category.name}}</h3></a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="city-area-two pb-70 pt-45" *ngIf="vendors"> 
    <div class="container">
        <!-- <div class="row align-items-center">
            <div class="col-lg-8">
                <div class="section-title">
                    <span>الأقسام الفرعية</span>
                    <h2>استكشف الأقسام الفرعية من القسم الرئيسي</h2>
                    <p>تصفح الأقسام الفرعية المختلفة التي نقدمها بناءً على اختيارك.</p>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="city-btn">
                    <a href="category" class="default-btn">عرض جميع الأقسام <i class='bx bx-plus'></i></a>
                </div>
            </div>
        </div> -->
        
        <div class="row pt-45">
            <div class="col-lg-4 col-md-12" *ngFor="let sub of vendors;let i = index;trackBy: trackById">
                <div class="city-card">
                    <div class="row content position-relative m-1">
                        <!-- <div class="restaurantStatus " *ngIf="sub.status === 'open'" [ngClass]="{'openRestaurant': sub.status === 'open'}">مفتوح</div>
                        <div class="restaurantStatus " *ngIf="sub.status === 'busy'" [ngClass]="{'busyRestaurant': sub.status === 'busy'}">مشغول</div>
                        <div class="restaurantStatus " *ngIf="sub.status === 'closed'" [ngClass]="{'closedRestaurant': sub.status === 'closed'}">مغلق</div> -->
                        <div class="col-lg-12 col-md-6 col-sm-6">
                            <a class="text-center"  [routerLink]="['/sub-category', sub.id, sub.name]" (click)="sendImage(sub?.avatar,sub.name)"><img src="{{sub?.avatar}}" alt="{{sub.name}}"></a>
                            <!-- [routerLink]="sub.status === 'open' ? ['/sub-category', sub.id, sub.name] : null" -->
                        </div>
                         <div class="col-lg-12 col-md-6 col-sm-6 text-center">
                            <p style="color: #000 !important;" class="mb-1 text-dark fs-3">{{sub.name}}</p>
                            <span style="color: #000 !important;">{{sub.city}} , {{sub.country}}</span>
                        </div>
                        <div class="">
                            <div class="city-card text-center mb-0">
                                <div class="content m-auto py-2 px-0" style="background-color: transparent !important;box-shadow: none !important;">
                                    <div class="vendorInfo-div" >
                                        <p style="border-right: 3px solid #000;padding-right: 10px;    direction: rtl;" class="mb-0">
                                            <img src="assets/img/clock-color-icon.png" width="25px" alt="clock"> {{sub.deliveryTime}}
                                        </p>
                                        <p style="padding-left: 10px;padding-right: 10px;direction: rtl;" class="mb-0">
                                            <img src="assets/img/food-delivery.png" width="25px" alt="clock"> {{sub.deliveryCost}}
                                        </p>
                                        <p style="padding-left: 10px;border-left: 3px solid #000;" class="mb-0">
                                            <span *ngIf="sub.current_status.is_open">
                                                <span class="restaurantStatus openRestaurant" *ngIf="sub.status === 'open'">
                                                    مفتوح
                                                </span>
                                                <span class="restaurantStatus busyRestaurant" *ngIf="sub.status === 'busy'">
                                                    مشغول
                                                </span>
                                                <span class="restaurantStatus closedRestaurant" *ngIf="sub.status === 'closed'">
                                                    مغلق
                                                </span>
                                            </span>
                                            <span *ngIf="!sub.current_status.is_open">
                                                <span class="restaurantStatus closedRestaurant">
                                                    مغلق
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-lg-12 col-md-6 col-sm-6">
                            <p class="mb-1 text-dark fs-3">{{sub.name}}</p>
                            <span>{{sub.city}} , {{sub.country}}</span>
                            <ul class="place-rating">
                                <li><a  [routerLink]="sub.status === 'open' ? ['/sub-category', sub.id, sub.name] : null" (click)="sendImage(sub.avatar,sub.name)">{{sub.rate}}</a></li>
                                <li>
                                    <i *ngFor="let star of [].constructor(sub.rate); let j = index" class="bx bxs-star"></i>
                                    <i *ngFor="let emptyStar of [].constructor(5 - sub.rate); let k = index" class="bx bxs-star icon-color"></i>
                                </li>
                                <span style="float: left;">{{sub.deliveryTime}}د <i class="bx bx-cycling"></i></span>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
            <div *ngIf="vendors.length == 0" style="color: red;" class="col-12 alert alert-danger">
                لا توجد بيانات
            </div>
        </div>
    </div>
</section>

<!-- <app-footer-style-two></app-footer-style-two> -->